import React from "react";
import PortfolioConfigData from "config/portfolio-config.json";
import EfficientFrontierCompareChart from "./components/EfficientFrontierCompareChart";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";

type SectionChildrenProps = {
  ef_data: any;
  data1: any;
  data2: any;
};

const EfficientFrontierCompareContainer: React.FC<SectionChildrenProps> = ({
  ef_data,
  data1,
  data2,
}) => {
  const selectedPlan1 = ef_data?.[data1?.data?.financial_plan - 1];
  const selectedPlan2 = ef_data?.[data2?.data?.financial_plan - 1];

  const portfolio1 = {
    risk: data1?.data?.var * 100,
    return: data1?.data?.return * 100,
  };
  const portfolio2 = {
    risk: data2?.data?.var * 100,
    return: data2?.data?.return * 100,
  };
  return (
    <div className={commonStyles.sectionContainer}>
      <h3 className={commonStyles.titleChart}>
        {
          PortfolioConfigData.analisi_rischio_rendimento_atteso.data
            .efficient_frontier_data.label
        }
      </h3>
      <div className={commonStyles.marginTop16}></div>
      <EfficientFrontierCompareChart
        data={ef_data}
        selectedPlan1={selectedPlan1}
        selectedPlan2={selectedPlan2}
        portfolio1={portfolio1}
        portfolio2={portfolio2}
      />
    </div>
  );
};

export default React.memo(
  EfficientFrontierCompareContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) =>
    prevProps.data1 === nextProps.data1 && prevProps.data2 === nextProps.data2,
);
